import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getParametres } from '../services/api';

const DEFAULT = {
  siteName:   "L'Envol Digital pour ELLES",
  tagline:    'Autonomiser les femmes entrepreneures par le numérique',
  email:      'contact@festicsn.com',
  phone:      '+221 78 131 82 11',
  adresse:    'Almadies Lot D – Mamelles Aviation – Face Ecole CEMAD Ngor Almadies 106',
  whatsapp:   '221781318211',
  facebook:   'https://facebook.com/envoldigital',
  instagram:  'https://instagram.com/envoldigital',
  linkedin:   'https://linkedin.com/company/envoldigital',
  tiktok:     '',
  youtube:    '',
  maintenanceMode:       false,
  notifEmailContact:     true,
  notifEmailInscription: true,
  notifEmailNewsletter:  false,
  notifSummaryWeekly:    true,
};

const SiteConfigContext = createContext({ config: DEFAULT, refetch: () => {} });

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT);

  const refetch = useCallback(async () => {
    try {
      const data = await getParametres();
      setConfig(prev => ({ ...prev, ...data }));
    } catch {
      // keep defaults on failure
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);

  return (
    <SiteConfigContext.Provider value={{ config, refetch }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSiteConfig() {
  return useContext(SiteConfigContext);
}
